import {ErrorCodeLang} from '../../Config/dataModel';
import {request} from './request';

const errorCode = (data: ErrorCodeLang) => {
    return request({
        url: '/public/errorCode',
        method: 'GET',
        params: data
    });
};

const errorCodeAPI = {errorCode};

export default errorCodeAPI


// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/errorCodeAPI.ts